module.exports = __webpack_public_path__ + "img/thumb-icon.42fb0948.svg";